import React, { useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

function DatatableShared({ items, filters, ITEMSFILTER, dataInfoColumn }) {
  const dt = useRef(null);
  return (
    <TabView>
      <TabPanel>
        <DataTable
          ref={dt}
          value={items}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={10}
          filters={filters}
          globalFilterFields={ITEMSFILTER}>
          {dataInfoColumn.map((item, index) => (
            <Column
              key={index}
              field={item.field}
              style={{ textAlign: "center", position: "relative" }}
              header={item.header}
              body={item.body ? item.body : null}></Column>
          ))}
        </DataTable>
      </TabPanel>
    </TabView>
  );
}

export default DatatableShared;
